import tagLinkSchema from '../tagLink/tagLinkSchema';
import { dbVersion } from '../../constants';

export default {
  title: 'tag schema',
  version: dbVersion,
  keyCompression: true,
  primaryKey: {
    key: 'pk_id',
    fields: ['id', 'workspaceId'],
    separator: '|',
  },
  type: 'object',
  required: [
    'pk_id',
    'id',
    'nextId',
    'title',
    'color',
    'items',
    'createdAt',
    'updatedAt',
    'workspaceId',
  ],
  properties: {
    pk_id: {
      type: 'string',
      maxLength: 100,
    },
    id: {
      type: 'string',
      maxLength: 100,
    },
    nextId: {
      type: ['string', 'null'],
    },
    title: {
      type: 'string',
    },
    color: {
      type: 'string',
    },
    items: {
      type: 'array',
      items: tagLinkSchema,
    },
    createdAt: {
      type: 'number',
    },
    updatedAt: {
      type: 'number',
    },
    workspaceId: {
      type: 'string',
      maxLength: 36,
    },
  },
  indexes: ['workspaceId'],
};
